module.exports = __webpack_public_path__ + "static/img/anli6.5da3be7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli/anli6.jpg
// module id = IpAb
// module chunks = 1